import React, { createContext, useCallback, useContext, useMemo } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

const defaultGoalsWeightContextState = {
  open: null,
  onSuccess: null,
  onCancel: null,
  fetchData: null,
  employeeId: null,
  canEdit: false,
  isPreSelectActiveGoals: false,
  preSelectedOptionId: '',
};

const GoalsWeightContext = createContext(defaultGoalsWeightContextState);

export const GoalsWeightProvider = ({ children }) => {
  // const [state, goalsWeightDispatch] = useReducer(goalsWeightActionsReducer, defaultGoalsWeightContextState);

  const history = useHistory();
  const { search } = useLocation();

  const existingSearch = useMemo(() => new URLSearchParams(search), [search]);

  const isSidepanelOpen = Boolean(existingSearch.get('showGoalWeightagePanel'));

  const state = useMemo(
    () => ({
      open: isSidepanelOpen,
      employeeId: existingSearch.get('goalWeightageEmployeeId'),
      canEdit: existingSearch.get('canEditGoalWeightage'),
      isPreSelectActiveGoals: Boolean(existingSearch.get('isPreSelectActiveGoals')),
      preSelectedOptionId: existingSearch.get('preSelectedOptionId'),
    }),
    [isSidepanelOpen, existingSearch]
  );

  const showSidePanel = useCallback(
    ({ showGoalWeightagePanel, employeeId, canEdit, preSelectedOptionId, isPreSelectActiveGoals }) => {
      existingSearch.set('showGoalWeightagePanel', showGoalWeightagePanel);
      existingSearch.set('goalWeightageEmployeeId', employeeId);
      existingSearch.set('canEditGoalWeightage', canEdit);
      if (preSelectedOptionId) {
        existingSearch.set('preSelectedOptionId', preSelectedOptionId);
      }
      existingSearch.set('isPreSelectActiveGoals', isPreSelectActiveGoals);

      history.push({
        search: existingSearch.toString(),
      });
    },
    [existingSearch, history]
  );

  const hideSidePanel = useCallback(() => {
    existingSearch.delete('showGoalWeightagePanel');
    existingSearch.delete('goalWeightageEmployeeId');
    existingSearch.delete('canEditGoalWeightage');
    existingSearch.delete('preSelectedOptionId');
    existingSearch.delete('isPreSelectActiveGoals');

    history.push({
      search: existingSearch.toString(),
    });
  }, [existingSearch, history]);

  return (
    <GoalsWeightContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        showSidePanel,
        hideSidePanel,
      }}
    >
      {children}
    </GoalsWeightContext.Provider>
  );
};

const useGoalsWeight = () => useContext(GoalsWeightContext);

export { useGoalsWeight };
